import axios from 'axios'

// sessionStorage仅在当前页面会话下有效, 所以getLocalProject用于支持不同页面访问不同项目
export const getLocalToken = () => localStorage.getItem("token");
export const getLocalStorageProject = () => localStorage.getItem("project");
export const getLocalStoragePreRoute = () => localStorage.getItem("preRoute");
export const getLocalProject = () => sessionStorage.getItem("project");
export const getLocalTaskForm = () => sessionStorage.getItem("taskForm");

export const saveLocalToken = (token: string) =>
  localStorage.setItem("token", token);

// 用于saveLocalProject和后台请求获取不到项目时
export const saveLocalStorageProject = (project: string) =>
  localStorage.setItem("project", project);

// 用于登陆跳转之前页面
export const saveLocalStoragePreRoute = (preRoute: string) =>
  localStorage.setItem("preRoute", preRoute);

export const saveLocalProject = (project: string) =>
  sessionStorage.setItem("project", project);

// 用于创建任务时, 即使用户切换or刷新页面也可以获取之前未完成的表单
export const saveLocalTaskForm = (taskForm: string) =>
  sessionStorage.setItem("taskForm", taskForm);

export const removeLocalToken = () => localStorage.removeItem("token");
export const removeLocalProject = () => sessionStorage.removeItem("project");
export const removeLocalTaskForm = () => sessionStorage.removeItem("taskForm");

// 从 sessionStorage 删除所有保存的数据
export const clearSessionStorage = () => sessionStorage.clear();

export function dateConversion(goal_date: any, add_day = 0) {
  // 字符串日期格式化 eg: return 2021-01-01 10:20:00
  if (goal_date) {
    goal_date = new Date(goal_date);
    goal_date.setDate(goal_date.getDate() + add_day);
    const month = goal_date.getMonth() + 1;
    const pad = (val: any) => {
      val = String(val);
      while (val.length < 2) {
        val = "0" + val;
      }
      return val;
    };
    return (
      pad(goal_date.getFullYear()) +
      "-" +
      pad(month) +
      "-" +
      pad(goal_date.getDate()) +
      " " +
      pad(goal_date.getHours()) +
      ":" +
      pad(goal_date.getMinutes()) +
      ":" +
      pad(goal_date.getSeconds())
    );
  } else {
    return "-";
  }
}

/**
 * 获取当前时间 格式：yyyy-MM-dd HH:MM:SS
 */
export function getCurrentTime() {
  const date = new Date(); //当前时间
  const month = zeroFill(date.getMonth() + 1); //月
  const day = zeroFill(date.getDate()); //日
  const hour = zeroFill(date.getHours()); //时
  const minute = zeroFill(date.getMinutes()); //分
  const second = zeroFill(date.getSeconds()); //秒

  //当前时间
  const curTime =
    date.getFullYear() +
    "-" +
    month +
    "-" +
    day +
    " " +
    hour +
    ":" +
    minute +
    ":" +
    second;

  return curTime;
}

/**
 * 补零
 */
export function zeroFill(i: any) {
  if (i >= 0 && i <= 9) {
    return "0" + i;
  } else {
    return i;
  }
}

export function formatDate(date: any) {
  date = date instanceof Date ? date : new Date();
  const pad = (val: any) => {
    val = String(val);
    while (val.length < 2) {
      val = "0" + val;
    }
    return val;
  };
  return (
    pad(date.getFullYear()) +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    " " +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds())
  );
}

// 传入type和对应的types字典，进行转换 eg: typeConversion(1, {0: paused, 1: running}) -> return running
export function typeConversion(type: any, types: any, control = false) {
  for (const [key, value] of Object.entries(types)) {
    if (String(key) === String(type)) {
      return value;
    } else if (String(type) === "-1") {
      return "无";
    }
  }
  if (control === true) {
    return type;
  }
  return "-";
}

// sort: 传入要排序的字段
export function compare(pro: string) {
  return function (obj1: any, obj2: any) {
    const val1 = obj1[pro];
    const val2 = obj2[pro];
    if (val1 < val2) {
      //正序
      return 1;
    } else if (val1 > val2) {
      return -1;
    } else {
      return 0;
    }
  };
}

// 利用set去重列表，但无法去除重复元素{}
export function unique(arr: any[]) {
  return Array.from(new Set(arr));
}

// 按照指定属性，去重json数组
export function unique_json(arr: any[], attr: string) {
  const res = new Map();
  return arr.filter((item) => {
    const attrItem = item[attr];
    return !res.has(attrItem) && res.set(attrItem, 1);
  });
}

export function alert_re_chinese(param: string) {
  alert(param + "只支持中英文、数字、下划线、横线、空格、英文冒号及英文句号");
}

export function alert_re_english(param: string) {
  alert(param + "只支持英文、数字、下划线、横线、空格、英文冒号及英文句号");
}

export function json_list_process(arr: any[], param: string) {
  arr.map((x) => x.param);
}

// 判断json格式
export function isJsonString(str: any) {
  try {
    if (typeof JSON.parse(str) == "object") {
      return true;
    }
  } catch (e) {
    return false;
  }
}

const Base64 = {
  //加密
  encode(str: any) {
    return btoa(
      encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
          return String.fromCharCode(("0x" as any) + p1);
        }
      )
    );
  },
  //解密
  decode(str: any) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(
      atob(str)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
  },
};

/**
 * 前端将字符串以文件形式导出
 * @param content 文件内容字符串
 * @param filename 文件名
 */

export function downFile(data?, fileName?) {
  if (typeof data == 'string') data = new Blob([data])

  const url = URL.createObjectURL(data)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName //设置下载的文件名
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export async function sleep(ms?) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true);
    }, ms);
  });
}

const regChinese = "^[\u4e00-\u9fa5A-Za-z0-9- （）().:_]+$";
const regEnglish = "^[\u4e00-\u9fa5A-Za-z0-9-.:_;<>@()（） ]+$";
export const regChineseObJ = new RegExp(regChinese);
export const regEnglishObj = new RegExp(regEnglish);
export const special_projects = {
  semi: [22], //半自动化项目
  cf: [4], //cf项目
  speedm: [7, 26], //QQ飞车项目
  aov: [14, 18, 23, 24],
  sgame: [9, 32, 28, 34, 35, 40], // 王者
  codm: [13, 15, 16],
  dfm: [8, 20, 21, 25, 54],
  cfr: [37],
  test: [11], // 测试项目,
  sg: [34, 40, 47],
};

export function gtAxios(config) {
  return axios(config)
}

export function grAxios(config) {
  return axios(config)
}

export default Base64;
